// @ts-ignore not typed yet
import AfterBeginPortal from 'ContentEditorUI/components/portals/AfterBeginPortal';
import { NAMESPACE_CLASS } from 'ContentEditorUI/lib/inpage/Constants';
import { DropZone } from 'foundations-components/transitional/components/DropZone';
import { EMPTY_PLACEHOLDER_ID_PARTIAL } from 'layout-dnd-utils/constants/dndAreaDomConstants';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getGridNodeElement } from 'layout-dnd-utils/grids/render/domSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export default function GridEmptyContainerPlaceholder({
  container,
  isHovered
}) {
  const containerElement = getGridNodeElement(container);
  const id = `${EMPTY_PLACEHOLDER_ID_PARTIAL}-${container.getId()}`;
  return /*#__PURE__*/_jsx(AfterBeginPortal, {
    id: id,
    namespace: NAMESPACE_CLASS,
    targetElement: containerElement,
    dataAttributes: {
      'hs-container-placeholder': 'true'
    },
    children: /*#__PURE__*/_jsx(DropZone, {
      size: "small",
      use: isHovered ? 'hover' : 'default',
      margin: "100",
      children: /*#__PURE__*/_jsx(Text, {
        color: "icon-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.layoutSection.dropZone"
        })
      })
    })
  });
}